export default function urlParser() {
  const params = Array.from(new URLSearchParams(window.location.search));
  if (!params.length) return null;

  return params.reduce((obj, item, index) => {
    obj[item[0]] = item[1];
    return obj;
  }, {});
}
